var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-settings-form" },
    [
      _c("table-columns-sidesheet", {
        ref: "tableColumnsModal",
        attrs: { columns: _vm.columns },
        on: { apply: _vm.saveColumns },
      }),
      _vm.loadingColumns
        ? _c("loader", {
            staticStyle: { "z-index": "1" },
            attrs: {
              label: "Данные загружаются",
              active: _vm.loadingColumns,
              height: "300",
            },
          })
        : _c("div", [
            _c(
              "section",
              { staticClass: "default-columns" },
              [
                _c("h2", { staticClass: "h2" }, [
                  _vm._v("Столбцы по умолчанию"),
                ]),
                _c("h-button", { on: { click: _vm.setDefaultColumns } }, [
                  _vm._v(" Настроить столбцы по умолчанию "),
                  _c("span", { staticClass: "columns-count" }, [
                    _vm._v(_vm._s(_vm.defaultColumnsLength)),
                  ]),
                ]),
              ],
              1
            ),
            _c(
              "section",
              { staticClass: "conditions" },
              [
                _c("h2", { staticClass: "h2" }, [_vm._v("Условия")]),
                _c("div", { staticClass: "conditions__note" }, [
                  _vm._v(
                    " С помощью условий можно настроить таблицу для ролей и должностей. Перетаскивайте условия, чтобы настроить приоритет их использования (чем выше условие, тем оно приоритетней). "
                  ),
                ]),
                _c("conditions", {
                  ref: "conditions",
                  staticClass: "conditions__list",
                  attrs: {
                    conditions: _vm.savedConditions,
                    columns: _vm.columns,
                  },
                }),
                _c("c-button-2", {
                  staticClass: "conditions__add",
                  attrs: {
                    size: "small",
                    icon: { icon: "plus", color: "primary" },
                    type: "with-icon",
                    label: "Добавить условие",
                  },
                  on: { click: _vm.addCondition },
                }),
              ],
              1
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }